module.exports = __webpack_public_path__ + "static/user-experience-7e9eb4640f0b0519c37543ffbf2a3464.png";